import { render } from "./LogoLink.vue?vue&type=template&id=d0899074&scoped=true"
import script from "./LogoLink.vue?vue&type=script&lang=js"
export * from "./LogoLink.vue?vue&type=script&lang=js"

import "./LogoLink.vue?vue&type=style&index=0&id=d0899074&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0899074"]])

export default __exports__